module.exports = __webpack_public_path__ + "img/barre-7.eaf7a79e.png";